import React, {useState} from 'react';
import {noop} from 'lodash';
import {useField} from 'formik';

import {InstitutionType} from 'shared/constants';
import InfoTooltip from 'shared/components/info-tooltip';
import InstitutionTypeahead, {Props as InstitutionTypeaheadProps} from './institution-typeahead';
import MissingHighSchoolModal from 'shared/missing-high-school-modal/components/missing-high-school-modal';

const InstitutionTypeaheadWithModal = ({
  typeaheadProps = {},
  institutionType,
  location,
  fieldName = 'currentInstitution',
  noTopPadding,
  renderLabel = ({singular}) => singular,
}: InstitutionTypeaheadProps) => {
  const [modal, setModal] = useState<string | null>('');
  const [field] = useField(fieldName);

  const showHighSchoolModal = () => {
    setHighSchoolModal(
      field.value.country === 'US' ? 'request-high-school' : 'find-international-high-school'
    );
  };

  const setHighSchoolModal = (name: string | null) => {
    setModal(name);
  };

  const renderEmptyResult = () => (
    <span className="cannot-find-high-school">Can&apos;t find your high school?</span>
  );

  const handleRenderLabel = ({singular, ...rest}: InstitutionType) => (
    <>
      {renderLabel({singular, ...rest})}
      <InfoTooltip placement="top">
        <div className="tips-section">
          <h5>{`Can't find your ${singular.toLowerCase()}?`}</h5>
          <ul>
            <li>Try the street address</li>
            <li>Use abbreviations (e.g. St. v. Saint)</li>
            <li>Raise Me does not support middle schools at this time.</li>
          </ul>
        </div>
      </InfoTooltip>
    </>
  );

  return (
    <>
      <MissingHighSchoolModal
        setHighSchoolModal={setHighSchoolModal}
        modal={modal}
        fieldName={fieldName}
      />
      <InstitutionTypeahead
        location={location}
        typeaheadProps={
          institutionType === 'high-school'
            ? {
                renderEmptyResult: renderEmptyResult,
                onSelectEmptyResult: showHighSchoolModal,
                ...typeaheadProps,
              }
            : {
                renderEmptyResult: () => 'No matches found.',
                onSelectEmptyResult: noop,
                ...typeaheadProps,
              }
        }
        renderLabel={handleRenderLabel}
        institutionType={institutionType}
        fieldName={fieldName}
        noTopPadding={noTopPadding}
      />
    </>
  );
};

export default InstitutionTypeaheadWithModal;
